// extracted by mini-css-extract-plugin
export default {"container":"styles_container__B-fIB","origen":"styles_origen__vlaqJ","downloadContent":"styles_downloadContent__JHp17"};